import ModelWithFacilityApi from "./ModelWithFacilityApi";

export default class TariffApi extends ModelWithFacilityApi {
	constructor(token, clientId, onUnauthorized) {
		super(token, clientId, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "tariffs/";
	}

}
